import { saveAs } from 'file-saver';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { SecuritiesPropertyFilter } from 'src/app/models/dtos/securities-property/securities-property-filter';
import { PaginationFilter } from 'src/app/models/pagination-filter';
import { SecuritiesProperty } from 'src/app/models/securities-property/securities-property';
import { environment } from 'src/environments/environment';
import { SecuritiesPropertyHistoric } from 'src/app/models/securities-property/securities-property-historic';
import { InviteUse } from 'src/app/models/securities-property/invite-use';
import { InviteExtraRelease } from 'src/app/models/securities-property/invite-extra-release';
import { InviteLimitSuspension } from 'src/app/models/securities-property/invite-limit-suspension';
import html2pdf from 'html2pdf.js';
import { SecuritiesPropetyFilterToReport } from 'src/app/models/dtos/securities-property/securities-propety-filter-to-report';

@Injectable({
  providedIn: 'root'
})
export class SecuritiesPropertyService {

  env:string = environment.apiHost + '/api-core/secure/securities-property';
  constructor(private http: HttpClient) { }

  getAllByFilter(filter:SecuritiesPropertyFilter,paginationFilter: PaginationFilter) : Observable<any> {
    let params = new HttpParams();
    let sort;
    if (paginationFilter.sort) {
      sort = paginationFilter.sort;
    }
    if (paginationFilter.order) {
      sort = (sort ? sort + ',' : '') + paginationFilter.order;
    }
    if (sort) {
      params = params.set('sort', sort);
    }
    params = params.set('page', paginationFilter.page.toString());
    params = params.set('size', paginationFilter.size.toString());
    return this.http
      .post(this.env + '/get-all-by-filter', filter, {
        params: params,
      })
      .pipe(map((response: any) => response));
  }

  getLast() : Observable<number> {
    return this.http.get<number>(this.env + '/get-last');

  }

  saveInLot(nStart: number, nEnd: number) : Observable<any> {
    return this.http.post(this.env + '/create-securities-in-lot/'+nStart +'/'+ nEnd,null).pipe(map((response: any) => response));
  }

  save(securitiesProperty:SecuritiesProperty) : Observable<any> {
    return this.http.post(this.env + '/save',securitiesProperty).pipe(map((response: any) => response));
  }

  getHistoric(id:number) : Observable<SecuritiesPropertyHistoric[]> {
    return this.http.get<SecuritiesPropertyHistoric[]>(this.env + '/get-historic/'+id);
  }

  getInviteUsed(id:number) : Observable<InviteUse[]> {
    return this.http.get<InviteUse[]>(this.env + '/list-invite/'+id);
  }

  /**
   * Registra liberação de compra adicional de convites (histórico do título).
   * Cabeçalhos MarinaId/UserId são enviados pelo interceptor.
   */
  addInviteToBuyHistoric(body: {
    securitiesPropertyId: number;
    date: string;
    numberInviteToBuy: number;
  }): Observable<InviteExtraRelease> {
    return this.http.post<InviteExtraRelease>(
      this.env + '/add-invite-to-buy-historic',
      body
    );
  }

  addFreeInviteHistoric(body: {
    securitiesPropertyId: number;
    date: string;
    numberInviteToBuy: number;
  }): Observable<InviteExtraRelease> {
    return this.http.post<InviteExtraRelease>(
      this.env + '/add-free-invite-historic',
      body
    );
  }

  blockInviteHistoric(historicId: number): Observable<SecuritiesPropertyHistoric> {
    return this.http.post<SecuritiesPropertyHistoric>(
      this.env + '/invite-historic/block/' + historicId,
      null
    );
  }

  findExtraReleasesByYear(
    securitiesPropertyId: number,
    year: number
  ): Observable<InviteExtraRelease[]> {
    return this.http.get<InviteExtraRelease[]>(
      this.env + '/invite-extra-release/' + securitiesPropertyId + '/' + year
    );
  }

  cancelExtraRelease(extraReleaseId: number): Observable<InviteExtraRelease> {
    return this.http.post<InviteExtraRelease>(
      this.env + '/invite-extra-release/cancel/' + extraReleaseId,
      null
    );
  }

  suspendInviteLimits(body: {
    securitiesPropertyId: number;
    date: string;
    note?: string;
  }): Observable<InviteLimitSuspension> {
    return this.http.post<InviteLimitSuspension>(
      this.env + '/invite-limit-suspension',
      body
    );
  }

  findSuspensionsByYear(
    securitiesPropertyId: number,
    year: number
  ): Observable<InviteLimitSuspension[]> {
    return this.http.get<InviteLimitSuspension[]>(
      this.env + '/invite-limit-suspension/' + securitiesPropertyId + '/' + year
    );
  }

  cancelSuspension(suspensionId: number): Observable<InviteLimitSuspension> {
    return this.http.post<InviteLimitSuspension>(
      this.env + '/invite-limit-suspension/cancel/' + suspensionId,
      null
    );
  }

  getTitlePropertiesByMarinaId():Observable<any>{
    return this.http
    .get(environment.apiHost + '/api-core/secure/securities-property/get-title-by-marina-id')
    .pipe(map((response: any) => response));
  }

  getTitlePropertiesTypeById(id: number):Observable<any>{
    return this.http
    .get(environment.apiHost + '/api-core/secure/securities-property/get-title-type-by-title-number/'+id)
    .pipe(map((response: any) => response));
  }

  getAssociateslist(filter:SecuritiesPropetyFilterToReport) : Observable<any> {
    return this.http.post(this.env + '/get-associates-by-filter',filter).pipe(map((response: any) => response));
  }

  buildPDF() {
          const element = document.getElementById('historic-table');
          const opt = {
              margin:      0,
              filename:     'HistReport.pdf',
              image:        { type: 'jpeg', quality: 0.98 },
              html2canvas:  { scale: 2, logging: true, useCORS: true },
              jsPDF:        {
                unit: 'in',
                format: 'a4',
                orientation: 'landscape',
                compress: true
              }
            };

          html2pdf()
            .from(element)
            .set(opt)
            .save();
      }

}
